import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalenderToday: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalenderToday"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM5 19H19V9H5V19Z" fill="currentColor"/><Path d="M10 14C10 12.8954 10.8954 12 12 12C13.1046 12 14 12.8954 14 14C14 15.1046 13.1046 16 12 16C10.8954 16 10 15.1046 10 14Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalenderToday;
